import { Navigate, useSearchParams } from 'react-router-dom';
import { AFFILIATE_TOKEN_STORAGE_KEY } from '../lib/affiliateToken';

/**
 * QrCapture — the landing target for an affiliate QR code
 * (/qrc?token=...). Stores the token client-side and hands off to the
 * normal entry flow; useAuth claims it against the traveler's profile the
 * moment they actually sign in (see claimAffiliateReferral in useAuth.ts),
 * which may be days later. Never blocks or redirects to anything
 * token-specific — a bad/missing token just falls through to the ordinary
 * "/" flow.
 */
export function QrCapture() {
  const [params] = useSearchParams();
  const token = params.get('token');

  if (token) {
    try {
      localStorage.setItem(AFFILIATE_TOKEN_STORAGE_KEY, JSON.stringify({ token, capturedAt: Date.now() }));
    } catch { /* localStorage unavailable (private mode, etc.) — just skip attribution */ }
  }

  return <Navigate to="/" replace />;
}

export default QrCapture;
